import React from "react";
import { cn } from "../../lib/cn";

/** Minimal hover title — replaces antd Tooltip for plain text hints */
export function Tooltip({ title, children, placement, className }) {
  return (
    <span
      className={cn("inline-flex cursor-help", className)}
      title={
        typeof title === "string" || typeof title === "number"
          ? String(title)
          : undefined
      }
      data-placement={placement}
    >
      {children}
    </span>
  );
}
